import React, {ReactNode} from "react";

import cx from "classnames";

import Button, {ButtonAccent} from "@components/Button";

import styles from "./ConfirmationModal.scss";

export type ConfirmationModalProps = {
  title: ReactNode;
  confirmationContent?: React.ReactNode;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onClose?: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
  btnClassName?: string;
  confirmBtnClassName?: string;
};

export default function ConfirmationModal({
  cancelButtonText = "cancel",
  confirmButtonText = "confirm",
  title,
  confirmationContent,
  onClose,
  onConfirm,
  onCancel,
  btnClassName,
  confirmBtnClassName,
}: ConfirmationModalProps): JSX.Element {
  const handleConfirm = () => {
    if (typeof onConfirm === "function") {
      onConfirm();
    }
    onClose?.();
  };

  const handleCancel = () => {
    if (typeof onCancel === "function") {
      onCancel();
    }
    onClose?.();
  };

  return (
    <div className={styles.modalContent}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.textContainer}>{confirmationContent}</div>
      <div className={styles.buttons}>
        {cancelButtonText && (
          <Button
            data-testid="confirm-modal-cancel"
            accent={ButtonAccent.AccentOrange}
            withThickBorder
            className={cx(styles.button, btnClassName)}
            onClick={handleCancel}
          >
            {cancelButtonText}
          </Button>
        )}
        <Button
          data-testid="confirm-modal-confirm"
          className={cx(styles.button, btnClassName, confirmBtnClassName)}
          onClick={handleConfirm}
        >
          {confirmButtonText}
        </Button>
      </div>
    </div>
  );
}
